<template>
  <v-container
    fluid
    py-0
    class="blue"
    style="position: fixed; overflow: scroll; height: 100vh"
  >
    <v-row align="center" justify="center" style="height: 100vh">
      <v-card class="pa-8 ma-5" width="380">
        <v-card-title class="d-flex justify-center" v-if="!showMessageSuccess">
          sweeep
        </v-card-title>
        <div v-if="showMessageSuccess">
          <p>{{ email }}</p>
          <span>にメールを送信しました。</span>
        </div>
        <div v-if="!showMessageSuccess">
          <v-form ref="form" v-model="valid" class="mb-4">
            <v-text-field
              label="登録済メールアドレス"
              v-model="email"
              :rules="emailRules"
              required
              validate-on-blur
              prepend-inner-icon="feather-mail"
              @keyup.enter="submit()"
            />
            <v-btn :loading="loading" block @click="submit()" class="mt-3"
              >パスワード再設定をリクエスト</v-btn
            >
          </v-form>
          <div class="text-center">
            <router-link to="/session/login">{{
              $t('message.backToSignIn')
            }}</router-link>
          </div>
        </div>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import SessionSliderWidget from 'Components/Widgets/SessionSlider'
import AppConfig from 'Constants/AppConfig'
import Vue from 'vue'
import Snackbar from 'Helpers/snackbar/index'

export default {
  components: {
    SessionSliderWidget,
  },
  data() {
    return {
      email: '',
      valid: false,
      showMessageSuccess: false,
      showMessageError: false,
      emailRules: [
        (v) => !!v || '※この項目は必須です',
        (v) =>
          /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(
            v
          ) || '正しい形式で入力ください',
      ],
      appLogo: AppConfig.appLogo2,
      loading: false,
    }
  },
  methods: {
    submit() {
      try {
        let hostUrl =
          process.env.VUE_APP_HOSTURL_EMAIL + 'session/reset-password/'
        if (this.$refs.form.validate()) {
          this.loading = true
          const apiUrl = this.$store.getters.apiForgotPasswordFunction
          const data = {
            email: this.email,
            url: hostUrl,
          }
          this.$store
            .dispatch('apiForgetPassword', {
              data,
              apiUrl,
            })
            .then((response) => {
              if (response.data.error) {
                Snackbar.error(
                  this.email + ' このメールアドレスは登録されていません'
                )
              }
              if (response.data.status == 'success') {
                this.showMessageSuccess = true
              } else {
                this.showMessageError = true
              }
              this.loading = false
            })
        }
      } catch {}
    },
  },
}
</script>
